import type { Action } from "./types";
import { router } from "../../App";

/**
 * Opens Curve Management in create mode with the selected curve pre-populated
 * as a copy.
 */
export const copyCurveAsCopy: Action = (ctx) => {
  if (ctx.disabledFeatures?.createCurve || !ctx.productId) return;

  router.navigate({
    to: "/app/curve-management",
    search: { mode: "create", copy: ctx.productId },
  });
};
